import Link from 'next/link';

const Select = ({ t, options, value, getFilterUrl }) => {
  return (
    <ul className="flex flex-col gap-7">
      {options.map(({ label, count }) => (
        <li key={label}>
          <Link href={getFilterUrl(label)} shallow passHref>
            <a type="button" href="_" className="group text-body-1 flex items-center gap-3">
              <span
                className={`-mt-[0.1875em] block h-3 w-3 border border-blue/10 lg:group-hover:border-blue ${
                  value.includes(label) ? 'bg-blue' : ''
                }`}
              />
              <span className="text-body-1 leading-none">
                {t(label)} ({count})
              </span>
            </a>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default Select;
